class DependantField {
  constructor(service, action, name, bodyName) {
    this.service = service;
    this.action = action;
    this.name = name;
    this.bodyName = bodyName;
  }
}

export { DependantField };
